import { Directive, HostListener, Injector, OnInit } from '@angular/core';
import { AbstractControl, NgControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

const NAME_PATTERN = /^(?![<\s.>])(?!.*[<\s.>]$)[a-zA-ZÀ-ÿčęàâæéêèëïîôœûùç0-9\s]+(?:[-_:%/\\()`\u2122.+][a-zA-ZÀ-ÿčęàâæéêèëïîôœûùç0-9)\s]+)*$/;

@Directive({
    selector: '[specialCharctersRestrict]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: SpecialCharactersRestrictDirective,
            multi: true,
        },
    ],
    standalone: false
})
export class SpecialCharactersRestrictDirective implements Validator, OnInit {
  private ngControl: NgControl | null = null;

  constructor(private injector: Injector) {}

  ngOnInit(): void {
    this.ngControl = this.injector.get(NgControl, null);
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value == null || value === '') {
      return { invalid: true };
    }
    const trimmed = String(value).trim();
    return trimmed && NAME_PATTERN.test(trimmed) ? null : { invalid: true };
  }

  @HostListener('blur')
  trimOnBlur(): void {
    trimControlValue(this.ngControl?.control);
  }
}

export function trimControlValue(control: AbstractControl | null | undefined): void {
  if (!control || typeof control.value !== 'string') {
    return;
  }
  const trimmed = control.value.trim();
  if (trimmed !== control.value) {
    control.setValue(trimmed);
  }
}
